<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-05 14:28:04
-->
<template>
  <div class="screen-root">
    <div id="screen">
      <TopHeader />
      <div class="main-content">
        <div class="left">
          <!-- 顶部统计卡片 -->
          <div class="card stats-card">
            <StatsCards />
          </div>
          <!-- 月采购统计折线图 -->
          <div class="card-group line-charts">
            <div class="card">
              <OrderLineChart />
            </div>
            <div class="card">
              <AmountLineChart />
            </div>
          </div>
          <!-- 产品类型统计 -->
          <div class="card-group type-charts">
            <div class="card">
              <SaleTypePie />
            </div>
            <div class="card">
              <SaleTypeBar />
            </div>
          </div>
          <!-- 商品排行 -->
          <div class="card-group rank-charts">
            <div class="card">
              <ProductSalesRank />
            </div>
            <div class="card">
              <ProductAmountRank />
            </div>
          </div>
        </div>
        <div class="center">
          <dv-border-box-8 :dur="4" class="flop">
            <Flop ref="Flop" />
          </dv-border-box-8>
          <div class="center-data">
            <div class="data-item">
              <div class="value">{{ totalData.totalSalesAmount }}</div>
              <div class="key">万象销售金额（万元）</div>
            </div>
            <div class="data-item">
              <div class="value">
                {{ totalData.ruralEconomyAmount }}
              </div>
              <div class="key">俪丰销售金额（万元）</div>
            </div>
            <div class="data-item">
              <div class="value">{{ totalData.ckPutTotalPriceTotal }}</div>
              <div class="key">联农销售金额（万元）</div>
            </div>
          </div>
          <div class="map">
            <button class="track-btn" @click="handleTrackClick">
              查看车辆送货行驶轨迹
            </button>
            <Map @change="handleMapIndexChange" />
          </div>
          <dv-decoration-12
            :scan-dur="4"
            :halo-dur="3"
            :color="['#00C0FE', 'transparent']"
          ></dv-decoration-12>
          <div class="card">
            <MapTable
              :item="mapActiveItem"
              @show="handleTableDetailShow"
              @showCompanyDetail="
                options => {
                  showDialog(7, options)
                }
              "
            />
          </div>
        </div>
        <div class="right">
          <!-- 学校采购排行 -->
          <div class="card card-school">
            <SchoolPurchaseRank />
          </div>
          <!-- 万象/联合体月度统计 -->
          <div class="card card-wanxiang">
            <WanxiangMonthlyStats />
          </div>
          <!-- 供应商销售排行 -->
          <div class="card card-supplier">
            <SupplierSalesRank />
          </div>
        </div>
      </div>
      <Product ref="ProductDialog" />
      <UserCus ref="UserCusDialog" />
      <BizCus ref="BizCusDialog" />
      <BizSupplier ref="BizSupplierDialog" />
      <UserOrder ref="UserOrderDialog" />
      <BizOrder ref="BizOrderDialog" />
      <TableDetail ref="TableDetail" />
      <AreaCompany ref="AreaCompany" />
      <AreaCompanyOrder ref="AreaCompanyOrder" />
      <GroupOrder ref="GroupOrder" />
    </div>
  </div>
</template>

<script>
import TopHeader from './components/TopHeader'
import StatsCards from './components/StatsCards'
import OrderLineChart from './components/OrderLineChart'
import AmountLineChart from './components/AmountLineChart'
import SaleTypePie from './components/SaleTypePie'
import SaleTypeBar from './components/SaleTypeBar'
import ProductSalesRank from './components/ProductSalesRank'
import ProductAmountRank from './components/ProductAmountRank'
import SchoolPurchaseRank from './components/SchoolPurchaseRank'
import WanxiangMonthlyStats from './components/WanxiangMonthlyStats'
import SupplierSalesRank from './components/SupplierSalesRank'
import Flop from './components/Flop'
import Map from './components/Map'
import MapTable from './components/MapTable'
import Product from './dialog/Product'
import UserCus from './dialog/UserCus'
import BizCus from './dialog/BizCus'
import BizSupplier from './dialog/BizSupplier'
import UserOrder from './dialog/UserOrder'
import BizOrder from './dialog/BizOrder'
import TableDetail from './dialog/TableDetail'
import AreaCompany from './dialog/AreaCompany'
import AreaCompanyOrder from './dialog/AreaCompanyOrder'
import GroupOrder from './dialog/GroupOrder'
import { getPlatformTotal } from '@/api/dashboard-tc'
import { ensureDashboardLogin } from '@/utils/dashboard-auth'
import to from 'await-to'
let _timer
export default {
  components: {
    TopHeader,
    StatsCards,
    OrderLineChart,
    AmountLineChart,
    SaleTypePie,
    SaleTypeBar,
    ProductSalesRank,
    ProductAmountRank,
    SchoolPurchaseRank,
    WanxiangMonthlyStats,
    SupplierSalesRank,
    Flop,
    Map,
    MapTable,
    Product,
    UserCus,
    BizCus,
    BizSupplier,
    UserOrder,
    BizOrder,
    TableDetail,
    AreaCompany,
    AreaCompanyOrder,
    GroupOrder,
  },
  data() {
    return {
      mapActiveItem: {},
      totalData: {},
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscKey)
    this.handleScreenAuto()
    window.onresize = () => this.handleScreenAuto()
    this.initNumData()
    _timer = setInterval(() => {
      this.initNumData()
    }, process.env.VUE_APP_LTIME_TC)
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEscKey)
    clearInterval(_timer)
    window.onresize = null
  },
  methods: {
    async initNumData() {
      const [res, err] = await to(getPlatformTotal())
      if (err) return
      this.$refs.Flop.initData(res.data.platformSaleTotal)
      this.totalData = res.data
    },
    //数据大屏自适应函数
    handleScreenAuto() {
      const designDraftWidth = 4096 //设计稿的宽度
      const designDraftHeight = 2160 //设计稿的高度
      //根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth / document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight
      //缩放比例
      document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`
    },
    showDialog(index, options) {
      console.log(`output->index`, this.$refs)
      for (const key in this.$refs) {
        if (Object.hasOwnProperty.call(this.$refs, key)) {
          const element = this.$refs[key]
          if (element.close) element.close()
        }
      }
      if (index == 1) {
        this.$refs['ProductDialog'].show()
      }
      if (index == 2) {
        this.$refs['UserCusDialog'].show()
      }
      if (index == 3) {
        this.$refs['BizCusDialog'].show()
      }
      if (index == 4) {
        this.$refs['BizSupplierDialog'].show()
      }
      if (index == 5) {
        this.$refs['UserOrderDialog'].show()
      }
      if (index == 6) {
        this.$refs['BizOrderDialog'].show()
      }
      if (index == 7) {
        this.$refs['AreaCompany'].show(options)
      }
      if (index == 8) {
        this.$refs['AreaCompanyOrder'].show()
      }
      if (index == 9) {
        this.$refs['GroupOrder'].show()
      }
    },
    handleTableDetailShow({ col, data }) {
      for (const key in this.$refs) {
        if (Object.hasOwnProperty.call(this.$refs, key)) {
          const element = this.$refs[key]
          if (element.close) element.close()
        }
      }
      this.$refs['TableDetail'].show(col, data)
    },
    handleEscKey(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        for (const key in this.$refs) {
          if (Object.hasOwnProperty.call(this.$refs, key)) {
            const element = this.$refs[key]
            if (element.close) element.close()
          }
        }
      }
    },
    async handleMapIndexChange(item) {
      this.mapActiveItem = item
    },
    // 查看车辆送货行驶轨迹（需验证平台密钥）
    async handleTrackClick() {
      if (!(await ensureDashboardLogin())) return
      window.open('http://gps51.com/#/login?username=广水车队视频监控&password=Aa1357')
    },
  },
}
</script>
<style lang="scss">
.screen-root {
  color: #fff;
  height: 100%;
  width: 100%;
  background-color: #050d4c;

  .bg {
    height: 100%;
    width: 100%;
  }

  #screen {
    overflow: hidden;
    display: inline-block;
    width: 4096px; //设计稿的宽度
    height: 2160px; //设计稿的高度
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    top: 0;

    .main-content {
      width: 100%;
      height: calc(100% - 161px);
      display: flex;
      box-sizing: border-box;

      > .left,
      > .right {
        box-sizing: border-box;
        height: 100%;
      }

      .left {
        padding: 20px 0 20px 37px;
        display: flex;
        flex-direction: column;
        height: 100%;
        box-sizing: border-box;
      }

      .right {
        padding: 20px 35px 20px 0;
        display: flex;
        flex-direction: column;
      }
    }

    .card {
      width: 1321px;
      background-size: contain;
      background-repeat: no-repeat;

      &.stats-card {
        height: 200px;
        flex-shrink: 0;
        background: transparent;
        border: 1px solid rgba(0, 192, 254, 0.3);
        border-radius: 8px;
        position: relative;
        margin: 10px 0;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent 0%, #00c0fe 50%, transparent 100%);
        }

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent 0%, #00c0fe 50%, transparent 100%);
        }
      }
    }

    .card-group {
      display: flex;
      justify-content: space-between;
      width: 1321px;

      &.line-charts,
      &.type-charts,
      &.rank-charts {
        flex: 1;
        min-height: 0;
        margin: 5px 0;
        .card {
          width: 654px;
          height: 100%;
          background-image: url('~@/img/datav-tc/card_bg.png');
          background-size: 100% 100%;
        }
      }
    }

    .right {
      .card-school {
        flex: 1.2;
        min-height: 0;
        background-image: url('~@/img/datav-tc/card_bg.png');
        background-size: 100% 100%;
      }

      .card-wanxiang {
        flex: 1;
        min-height: 0;
        background-image: url('~@/img/datav-tc/card_bg.png');
        background-size: 100% 100%;
      }

      .card-supplier {
        flex: 1.2;
        min-height: 0;
        background-image: url('~@/img/datav-tc/card_bg.png');
        background-size: 100% 100%;
      }
    }

    .center {
      overflow: hidden;
      box-sizing: border-box;
      position: relative;
      height: 100%;
      padding: 35px 36px 0 36px;

      .flop {
        width: 1305px;
        height: 250px;
        background: url('~@/img/datav-tc/flop_bg.png') no-repeat center;
        margin-bottom: 4px;
      }

      .map {
        margin-top: -43px;
        position: relative;
        width: 1306px;
        height: 1144px;
        background: url('~@/img/datav-tc/map_bg.png') no-repeat center;
        margin-bottom: 16px;

        .map-container {
          position: relative;
          z-index: 999;
        }

        .track-btn {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1000;
          height: 64px;
          padding: 0 28px;
          font-size: 24px;
          letter-spacing: 2px;
          color: rgba(160, 222, 255, 0.9);
          cursor: pointer;
          border: 1px solid rgba(0, 192, 254, 0.35);
          border-radius: 4px;
          background: rgba(5, 30, 80, 0.35);
          transition: all 0.3s;

          &::before,
          &::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(
              90deg,
              transparent 0%,
              rgba(0, 192, 254, 0.6) 50%,
              transparent 100%
            );
          }

          &::before {
            top: 0;
          }

          &::after {
            bottom: 0;
          }

          &:hover {
            color: #fff;
            border-color: rgba(0, 192, 254, 0.8);
            background: rgba(0, 80, 160, 0.45);
            box-shadow: 0 0 10px rgba(0, 192, 254, 0.35);
          }
        }
      }

      .card {
        position: relative;
        z-index: 9999;
        height: 387px;
        background-image: url('~@/img/datav-tc/card_bg_4.png');
        background-color: #050d4c;
      }

      .dv-decoration-12 {
        z-index: 699;
        position: absolute;
        left: 51%;
        top: 56%;
        transform: translate(-50%, -50%);
        width: 1220px;
        height: 1220px;
      }

      .center-data {
        width: 1305px;
        display: flex;
        justify-content: center;

        .data-item {
          width: 287px;
          height: 196px;
          text-align: center;
          padding-top: 8px;
          margin-right: 111px;

          &:last-of-type {
            margin-right: 0;
          }

          .value {
            line-height: 64px;
            font-weight: normal;
            font-size: 48px;
            color: #ecf8ff;
            margin-bottom: 4px;
            white-space: nowrap;

            .tip {
              font-size: 18px;
              line-height: 18px;
            }
          }

          .key {
            line-height: 21px;
            font-weight: normal;
            font-size: 21px;
            color: #e0eafa;
          }

          &:nth-of-type(1) {
            background: url('~@/img/datav-tc/center_data_bg_1.png');
          }

          &:nth-of-type(2) {
            background: url('~@/img/datav-tc/center_data_bg_2.png');
          }

          &:nth-of-type(3) {
            background: url('~@/img/datav-tc/center_data_bg_3.png');
          }
        }
      }
    }
  }
}
</style>
